export class UserAccountConstants {
  PasswordPattern = '^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[^a-zA-Z\\d\\s:]).{8,}$';
  PasswordPatternErrorMessage = 'Le mot de passe ne satisfait pas les règles de sécurité (au moins 8 caractères dont 1 lettre, 1 chiffre, et 1 caractère spécial)';
}
